import axios from "axios";
import { GRAPH_QL_CRASH } from "../../utils/Enviroment";

/**
 * Generic GraphQL caller using Axios
 * @param {string} query - The GraphQL query string
 * @param {object} variables - Optional variables
 * @returns {Promise<object>} - Returns the data or throws error
 */

export const callCrashGameGraphQLQuery = async (query, variables = {}) => {
  try {
    const response = await axios.post(
      GRAPH_QL_CRASH,
      {
        query,
        variables,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error("GraphQL returned errors");
    }
    // console.log(response.data.data, "response.data.data");
    return response.data.data;
  } catch (error) {
    console.error("GraphQL Request Failed:", error);
    throw error;
  }
};
